import { render, staticRenderFns } from "./editor-detail.vue?vue&type=template&id=cf79ef88&"
import script from "./editor-detail.vue?vue&type=script&lang=js&"
export * from "./editor-detail.vue?vue&type=script&lang=js&"
import style0 from "./editor-detail.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports